<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="asinInfo.title"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >
        <el-input type="textarea" v-model="asinInfo.info" :rows="5"></el-input>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleUpdate" type="primary" v-show="info.update">修 改</el-button>

            <el-button @click="handleClose" type="primary" v-show="!info.update">关 闭</el-button>
          </span>

    </el-dialog>
</template>
<script>

import * as api from '@/api/advAnalys/advAnalys'
import {cost_analysis_personal_update_field, low_price_mall_common_update_field} from '@/api/advAnalys/advAnalys'

export default {
    data() {
        return {
            asinInfo: {},
            list: [],
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        closeFlag: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: {}
        },
    },
    watch: {
        visible: {
            handler(val) {
                if (val) {
                    this.asinInfo = JSON.parse(JSON.stringify(this.info))
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 关闭弹窗
        handleClose() {
            this.$emit('close-callback', this.closeFlag)
        },
        handleUpdate() {
            this.loading = true
            api.cost_analysis_personal_update_field({id: this.asinInfo.id, remark: this.asinInfo.info}).then(res => {
                if (res.code == 0) {
                    this.$message({message: '修改成功', type: 'success'})
                    this.closeCllback(true)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
            }).finally(() => {
                this.loading = false
            })
        },
        closeCllback(isshow = false) {
            this.asinInfo = {};
            this.$emit("close-callback", isshow);
        }
    }
}
</script>
<style type="text/scss" lang="scss">
.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>

